import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import BannerComp from "../Components/BannerComp";
import moment from "moment";
import { Button, Divider, Empty, Image, Spin } from "antd";
import { BsFillFileEarmarkPostFill } from "react-icons/bs";
import Footer from "../Components/Footer";
import { Fade } from "react-awesome-reveal";
// import exibitionBanner from "../Assets/exibition.jpeg";
import { get } from "../apiService";
import carat from "../Assets/education/4Cs/carat_template-transformed.jpeg";
import { MetaTags } from "react-meta-tags";

export default function Exibition() {
  const [visible, setVisible] = useState({ visible: false, image: "" });
  const [exhibition, setExhibition] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    totalPage: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize);
    }, 300);

    return () => clearTimeout(dbounce);
    // eslint-disable-next-line
  }, []);

  const fetchData = async (current, pageSize) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/exibition.php?limit=${pageSize}&page=${current}&type=exhibition&action=${action}`
      );
      setExhibition(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total,
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MetaTags>
        <title>Best Diamond Exhibition | Sejal Exports</title>
        <meta title="Best Diamond Exhibition | Sejal Exports" />
        <meta name="description" content=" Experience the Best Diamond Exhibition featuring a stunning collection of diamonds and fine jewellery. Explore dazzling pieces, network with industry experts." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/best-diamond-exhibition" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Diamond Exhibition | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content=" Experience the Best Diamond Exhibition featuring a stunning collection of diamonds and fine jewellery. Explore dazzling pieces, network with industry experts." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>
      <Spin spinning={loading}>
        <Header />
        <BannerComp
          title="Our Exibitions"
          breadcrumb={[
            {
              title: "Home",
              href: "/",
            },
            {
              title: "Exibitions",
            },
          ]}
          image={carat}
        />
        <section className="sectionDiv">
          <div className="container">
            <div className="exhibitionList">
              <h2>UPCOMING EXHIBITIONS</h2>
              {exhibition?.length > 0 ? (
                exhibition
                  .filter((val) => {
                    const startDate = moment(val.exibition_date);
                    const endDate = moment(val.exibition_end);
                    const currentDate = moment(new Date());

                    // Exhibition is ongoing
                    return (
                      startDate.isSameOrAfter(currentDate) || // Dates in the future
                      (startDate.isSameOrBefore(currentDate) && endDate.isSameOrAfter(currentDate)) // Ongoing
                    );
                  })
                  .map((val, index) => (
                    <Fade className="w-100" triggerOnce direction="up">
                      <div className="exhibitionCard" key={index}>
                        <div className="cardHeader">
                          <h3>{val.title}</h3>
                          <Button
                            className="bg-danger text-white"
                            icon={<BsFillFileEarmarkPostFill />}
                            onClick={() =>
                              setVisible({
                                visible: true,
                                image: val.image,
                              })
                            }
                          />
                        </div>
                        <p>
                          <span>
                            <strong>Date: </strong>
                            {moment(val.exibition_date).format(
                              "MMMM DD YYYY"
                            )} -{" "}
                            {moment(val.exibition_end).format("MMMM DD YYYY")}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>venue: </strong>
                            {val.venau}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>Booth No: </strong>
                            {val.booth_no}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>Booth Name: </strong>
                            {val.booth_name}
                          </span>
                        </p>
                      </div>
                    </Fade>
                  ))
              ) : (
                <Empty />
              )}
            </div>
            <Divider />
            <div className="exhibitionList">
              <h2>PAST EXHIBITIONS</h2>
              {exhibition?.length > 0 ? (
                exhibition
                  .filter((val) => {
                    const startDate = moment(val.exibition_end);
                    const currentDate = moment(new Date());
                    return startDate.isSameOrBefore(currentDate);
                  })
                  .map((val, index) => (
                    <Fade className="w-100" triggerOnce direction="up">
                      <div className="exhibitionCard" key={index}>
                        <div className="cardHeader">
                          <h3>{val.title}</h3>
                          <Button
                            className="bg-danger text-white"
                            icon={<BsFillFileEarmarkPostFill />}
                            onClick={() =>
                              setVisible({
                                visible: true,
                                image: val.image,
                              })
                            }
                          />
                        </div>
                        <p>
                          <span>
                            <strong>Date: </strong>
                            {moment(val.exibition_date).format(
                              "MMMM DD YYYY"
                            )} -{" "}
                            {moment(val.exibition_end).format("MMMM DD YYYY")}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>venue: </strong>
                            {val.venau}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>Booth No: </strong>
                            {val.booth_no}
                          </span>
                          <span className="mx-1">|</span>
                          <span>
                            <strong>Booth Name: </strong>
                            {val.booth_name}
                          </span>
                        </p>
                      </div>
                    </Fade>
                  ))
              ) : (
                <Empty />
              )}
            </div>
          </div>
        </section>

        <Image
          width={200}
          style={{
            display: "none",
          }}
          src={`${visible.image}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
          preview={{
            visible: visible.visible,
            src: visible.image,
            onVisibleChange: (value) => {
              setVisible({ visible: false, image: "" });
            },
          }}
        />

        <Footer />
      </Spin>
    </>
  );
}
